import { BaseService } from "../BaseService";
import { BookingStatusBaseService } from "./BookingStatusBaseService";
import { AuthService } from "../auth/auth.service";
import { environment } from '../../../../src/environments/environment';
import { HttpClient } from "@angular/common/http";
import { Router } from '@angular/router';
import { Observable, of, throwError } from "rxjs";
import { catchError, concatMap, delay, map, retryWhen, take } from 'rxjs/operators';
import { ApiResult } from "../../models/ApiResult";
import { BookingStatusModel } from "../../models/api/BookingStatusModel";
import { BookingStatusFindResultModel } from "../../models/api/BookingStatusFindResultModel";
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})

export class BookingStatusService extends BookingStatusBaseService {

    constructor(private h: HttpClient, private r: Router, private a: AuthService) {
        super(h, r, a);
    };

}
